const getCompanyType = (orgnr) => {
    if (!orgnr) {
        return ''
    }
    const companyType = parseInt(orgnr.substring(2, 4), 10) > 12 ? 'company' : 'private'
    return companyType
}

export default getCompanyType